import React, { Component } from 'react'

import styles from './styles.scss'

/** Components */
import IconComponent from '@/components/commons/IconComponent'
import Button from '@/components/Button'

class FirstMagazine extends Component {
  render () {
    return (
      <section className={styles['wrapper-first-magazine']}>
        <div className={styles['wrapper-first-magazine__content']}>
          <h1>Crie sua revista</h1>
          <p>Crie sua primeira revista e começe a conquistar o mundo.</p>
          <Button
            size="large"
          >
            <IconComponent icon="magazine" />
            Crie agora
          </Button>
          <div className={styles['wrapper-first-magazine__content-illustration']} />
        </div>
      </section>
    )
  }
}

export default FirstMagazine


// WEBPACK FOOTER //
// ./src/pages/FirstMagazine/index.js